import {lazy, Suspense} from "react";
import CircularLoader from "../../customs/loader/main";


const Main = lazy(() => import("../../components/members/licenseRegister/main"));


const LicenseRegister = () => {

    return(
        <Suspense fallback={<CircularLoader/>}>
            <Main/>
        </Suspense>    
    )
};

export default LicenseRegister;